.container {
  display: grid;
  gap: 8px;
  align-items: center;
  text-align: center;
}

.link {
  width: 240px;
  padding-top: 12px;
  padding-bottom: 12px;
  font-size: 15px;
  font-weight: 600;
  line-height: 24px;
  color: #fff;
  background-color: #000;
  border-radius: 8px;

  &:hover {
    background-color: rgb(77 77 77);
  }
}

.text {
  font-size: 12px;
  font-weight: 300;
  line-height: 1.8;
  color: rgb(0 0 0 / 70%);
}

@container press-release-root (min-width: 350px) {
  .linkCQ {
    width: 280px;
  }
}

@container press-release-root (min-width: 400px) {
  .linkCQ {
    width: 316px;
  }
}

@container press-release-root (min-width: 1024px) {
  .linkCQ {
    width: 216.5px;
  }

  .textCQ {
    font-size: 13px;
  }
}

@media screen and (width >= 350px) {
  .linkFallback {
    width: 280px;
  }
}

@media screen and (width >= 400px) {
  .linkFallback {
    width: 316px;
  }
}

@media screen and (width >= 1024px) {
  .linkFallback {
    width: 216.5px;
  }

  .textFallback {
    font-size: 13px;
  }
}
